'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var _enUS = require('./icons/en-US');

var _enUS2 = _interopRequireDefault(_enUS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({
  IndexFilters: {
    filters: '{quantity, plural,\n  =0 {筛选}\n  =1 {1 个筛选}\n  ' + 'other {# 筛选}\n}'
  }
}, _enUS2.default, {
  Active: '活动',
  Activate: '激活',
  Activated: '已激活',
  Add: '添加',
  add: '添加',
  Alerts: '警报',
  All: '全部',
  ampm: 'ampm',
  Arc: '存档',
  AxisLabel: '{orientation} 轴',
  area: '区域',
  Bar: '栏',
  bar: '栏',
  Blank: '空白',
  Box: '框',
  Carousel: '传送',
  Category: '类别',
  Circle: '圆',
  Chart: '图表',
  Children: '子项',
  Clear: '清除',
  Cleared: '已清除',
  Close: '关闭',
  'Close Menu': '关闭菜单',
  Completed: '已完成',
  'Connects With': '连接对象',
  created: '已创建',
  Critical: '严重',
  'Currently Active': '当前处于活动状态',
  'Date Selector': '日期选择器',
  'Date Time Icon': '打开日期和时间选择器',
  day: '天',
  Disabled: '已禁用',
  Distribution: '分布',
  Email: '电子邮件',
  'Enter Select': '按 Enter 进行选择',
  Error: '错误',
  Filter: '筛选',
  Footer: '页脚',
  Grommet: 'Grommet',
  HotSpotsLabel: '热点: 按箭头键可与它进行交互',
  'GraphValues': '图有 {count} 项。最大值为 {highest}，' + ' 最小值为 {smallest}',
  hour: '小时',
  'Grommet Logo': 'Grommet 徽标',
  'Layer': '层',
  List: '列表',
  line: '线',
  'Loading': '正在加载',
  loginInvalidPassword: '请提供用户名和密码。',
  'Log In': '登录',
  Logout: '注销',
  'Main Content': '主要内容',
  Max: '最大值',
  Menu: '菜单',
  Meter: '度量',
  Min: '最小值',
  minute: '分钟',
  model: '型号',
  modified: '已修改',
  monitor: '监控',
  month: '月',
  'Multi Select': '多重选择',
  Name: '名称',
  'Navigation Help': '使用箭头键导航',
  'Next Month': '下个月',
  'Next Slide': '下一张幻灯片',
  'No Relationship': '无关系',
  'Notification': '通知',
  OK: '确定',
  Open: '打开',
  Parent: '父项',
  Parents: '父项',
  Parts: '部分',
  Part: '部分',
  Password: '密码',
  'Previous Month': '上个月',
  'Previous Slide': '上一张幻灯片',
  'Previous Tiles': '之前的磁贴',
  'Remember me': '记住我',
  Resource: '资源',
  Running: '正在运行',
  Search: '搜索',
  'Match Results': 'There {count, plural,\n      =0 {is no match}\n      one {is # match}\n      other {are # matches}\n  }',
  second: '秒',
  'Select Icon': '打开选择下拉列表',
  Selected: '已选择',
  'Selected Multiple': '{count, plural,\n      =0 {none}\n      one {# value}\n      other {# values}\n  }',
  'Skip to': '跳转到',
  'Slide Number': '幻灯片 {slideNumber}',
  Sort: '排序',
  Spinning: '旋转',
  Spiral: '螺旋',
  State: '状况',
  Status: '状态',
  Subtract: '减去',
  SunBurst: 'SunBurst',
  'Tab Contents': '{activeTitle} 选项卡内容',
  Table: '表',
  Tasks: '任务',
  Tiles: '磁贴',
  Time: '时间',
  Title: '标题',
  Today: '今天',
  Topology: '拓扑',
  Total: '总计',
  Threshold: '阈值',
  Unknown: '未知',
  Username: '用户名',
  uri: 'URI',
  Value: '值',
  Warning: '警告',
  year: '年'
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/grommet/messages/zh-CN.js
// module id = 134
// module chunks = 0